// extracted by mini-css-extract-plugin
export default {"pageWrap":"wb-z","fullWidth":"xb-z","heading":"yb-z","fullBleed":"zb-z","hidden":"Ab-z"};